import { isClient, isNotPresent, isPresent } from '../utils';

const storageAvailable = (storageName: string): boolean => {
  try {
    const x = '__storage_test__';
    window[storageName].setItem(x, x);
    window[storageName].removeItem(x);
    return true;
  } catch (e) {
    return false;
  }
};

export interface Storage {
  set: (key: string, data: unknown) => void;
  get: <T>(key: string) => T;
}

const getStorage = (storageName: string): Storage => {
  const hasStorage = isClient() && storageAvailable(storageName);
  return {
    set(key: string, data: unknown): void {
      if (hasStorage && isPresent(data)) {
        try {
          window[storageName].setItem(key, JSON.stringify(data));
        } catch (e) {}
      }
    },
    get<T>(key: string): T {
      if (hasStorage) {
        try {
          const data: string = window[storageName].getItem(key);
          if (isNotPresent(data)) {
            return undefined;
          }

          return JSON.parse(data);
        } catch (e) {
          return undefined;
        }
      }
      return undefined;
    },
  };
};

export const storage = {
  local: getStorage('localStorage'),
  session: getStorage('sessionStorage'),
};
